module.exports = __webpack_public_path__ + "fonts/3b5a7b6a-e026-4ee8-b80f-6aa5e44b2977.84e01e7b.woff";